import {MI} from "../init";
import ServerResult from "../ServerResult";
import ResultController from "./ResultController";

import events from "../../framework/src/events/EventsObservable";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {freespins, wallet} from "../../framework/src/engine/madnes/madnes_variables";

import * as MV from "../../framework/src/engine/madnes/madnes_variables";
import AddResult from "../../framework/src/connect/result/AddResult";
import {madnes_add_win, madnes_reels_start, madnes_reels_stop} from "../../framework/src/engine/madnes/madnes";
import {STATES} from "../../framework/src/states/states";


/**
 * @constructor
 */
export default function Game() {
    /** @type {boolean} */
    this.inPreinfo = false;

    /** @type {GameConfig} */
    this.gameCfg;

    /** @type {SpinReels} */
    this.spinReels;

    /** @type {ReelPrinter} */
    this._printer;

    /** @type {ServerConfig} */
    this._serverConfig;

    /** @type {ResultController} */
    this._resultController;

    /** @type {SymbolsManager} */
    this._symbolsManager;

    /** @type {GameAssets} */
    this.assets;

    this._SPINNING = false;

    /** @type {ServerResult} */
    this._serverResult = new ServerResult();

    /** @type {ServerResult|null|undefined} */
    this._fsServerResult = null;

    this.gameRoundWin = 0;
    this.gameTotalCredit = 0;

    this.inBonusChoose = false;

    /** @type {boolean} */
    this.inFreeSpins = false;

    this.inFreeSpinsIndex = -1;

    this._resultRequestLock = false;

    /** @type {Promise|null} */
    this.waitForWinAdd = null;

    this.freeSpinData = {
        'roundWin': 0,
        'count': 0,
        'pos': 0
    };

    /** @type {Object<string,MadnesAudio>} */
    this.sounds = {};

    /** @type {boolean} */
    this._forceStopSoundPlayed = false;

    /** @type {boolean} */
    this._forceScatterSoundPlayed = false;

    /** @type {boolean} */
    this._forceWildSoundPlayed = false;

    this.spinEnabled = true;

    this._forceAutostartEnabled = false;

    this._removeBetEnabled = true;

    /**
     * @type {number}
     * @private
     */
    this._stoppedScatterIndex = 0;
};

Game.prototype = {

    /** @const */
    NORMAL_WIN: 0,
    /** @const */
    BIG_WIN: 1,
    /** @const */
    MEGA_WIN: 2,
    /** @const */
    SUPER_MEGA_WIN: 3,
    /** @const */
    BONUS_WIN: 4,

    reinitFreespinData: function() {
        this.freeSpinData = {
            'roundWin': 0,
            'count': 0,
            'pos': 0
        };
    },

    /**
     * @returns {boolean}
     */
    stopBonusScatterSound: function() {
        return this.fsChoosed()
        //return !!(!this._fsServerResult && this._serverResult.getFreeSpinResults());
    },

    _playBgScatterIdle: function() {
        var _self = this;

        MI.createTimer().add(function() {
            if(_self.inBonusChoose) {
                _self.sounds["bg_Scatter_Idle"].loop();
            }
        }, 10500);
    },

    /**
     * @param {SpinReels} spinReels
     * @param {GameConfig} gameConfig
     * @param {ReelPrinter} reelPrinter
     * @param {ServerConfig} serverConfig
     * @param {SymbolsManager} symbolsManager
     * @param {GameAssets} gameAssets
     * @returns {undefined}
     */
    init: function(spinReels, gameConfig, reelPrinter, serverConfig, symbolsManager, gameAssets) {

        this.spinReels = spinReels;
        this.gameCfg = gameConfig;
        this._printer = reelPrinter;
        this._serverConfig = serverConfig;
        this._symbolsManager = symbolsManager;
        this.assets = gameAssets;

        this._resultController = new ResultController(this, symbolsManager);
        this._resultController.init();

        this.sounds["bg_Music"] = MI.addAudio("bg_Music").loop();

        this.sounds["bonus_FreeSpins_Counter"] = MI.addAudio("bonus_FreeSpins_Counter").allowMultiple();

        this.sounds["bg_FreeSpins_Start"] = MI.addAudio("bg_FreeSpins_Start");
        this.sounds["bg_FreeSpins_Loop"] = MI.addAudio("bg_FreeSpins_Loop");

        this.sounds["bonus_Wild_Shuffle"] = MI.addAudio("bonus_Wild_Shuffle");
        this.sounds["bonus_Wild_Random"] = MI.addAudio("bonus_Wild_Random").allowMultiple();
        this.sounds["symbol_Wild_Start"] = MI.addAudio("symbol_Wild_Start");

        this.sounds["symbol_Wild"] = MI.addAudio("symbol_Wild").allowMultiple();
        this.sounds["bonus_Wild_Changing_1"] = MI.addAudio("bonus_Wild_Changing_1");
        this.sounds["bonus_Wild_Changing_2"] = MI.addAudio("bonus_Wild_Changing_2");
        this.sounds["bonus_Wild_Changing_4"] = MI.addAudio("bonus_Wild_Changing_4");

        this.sounds["symbol_Scatter_1"] = MI.addAudio("symbol_Scatter_1");
        this.sounds["symbol_Scatter_2"] = MI.addAudio("symbol_Scatter_2");
        this.sounds["symbol_Scatter_3"] = MI.addAudio("symbol_Scatter_3");

        this.sounds["bonus_Scatter_1"] = MI.addAudio("bonus_Scatter_1");
        this.sounds["bonus_Scatter_2"] = MI.addAudio("bonus_Scatter_2");
        this.sounds["bonus_Scatter_3"] = MI.addAudio("bonus_Scatter_3");

        this.sounds["bonus_Paper_1"] = MI.addAudio("bonus_Paper_1");
        this.sounds["bonus_Paper_2"] = MI.addAudio("bonus_Paper_2");
        this.sounds["bonus_Paper_3"] = MI.addAudio("bonus_Paper_3");
        this.sounds["bonus_Scatter_Pick"] = MI.addAudio("bonus_Scatter_Pick");
        this.sounds["bg_Scatter_Idle"] = MI.addAudio("bg_Scatter_Idle");

        this.sounds["bonus_Wild_Expand_Online"] = MI.addAudio("bonus_Wild_Expand_Online");

        this.sounds["win_Expand_1"] = MI.addAudio("win_Expand_1");
        this.sounds["win_Expand_2"] = MI.addAudio("win_Expand_2");
        this.sounds["win_Expand_3"] = MI.addAudio("win_Expand_3");

        this.sounds["bwin_FreeSpins"] = MI.addAudio("bwin_FreeSpins");

        for(var i = 1; i <= 15; i++) {
            this.sounds["bonus_Wild_Changing_3_" + i] = MI.addAudio("bonus_Wild_Changing_3_" + i);
        }

        this.sounds["reel_Spin"] = MI.addAudio("reel_Spin").allowMultiple();
        this.sounds["reel_Stop"] = MI.addAudio("reel_Stop").allowMultiple();

        this.sounds["win_Multiplier"] = MI.addAudio("win_Multiplier");

        this.sounds["bwin_BigWin"] = MI.addAudio("bwin_BigWin");
        this.sounds["bwin_BigWin_End"] = MI.addAudio("bwin_BigWin_End");

        this.sounds["ui_Counter"] = MI.addAudio("remittance_A");
        this.sounds["ui_Counter_Stop"] = MI.addAudio("remittance_B");

        for(var i = 2; i <= 5; i++) {
            this.sounds["win_Ring_" + i + "x"] = MI.addAudio("win_Ring_" + i + "x");
            this.sounds["win_RedCrystal_" + i + "x"] = MI.addAudio("win_RedCrystal_" + i + "x");
            this.sounds["win_BlueCrystal_" + i + "x"] = MI.addAudio("win_RedCrystal_" + i + "x");
            this.sounds["win_Coin_" + i + "x"] = MI.addAudio("win_Coin_" + i + "x");
        }

        for(var i = 3; i <= 5; i++) {
            this.sounds["win_FlaskMid_" + i + "x"] = MI.addAudio("win_FlaskMid_" + i + "x");
            this.sounds["win_FlaskLow_" + i + "x"] = MI.addAudio("win_FlaskLow_" + i + "x");
            this.sounds["win_FlaskHigh_" + i + "x"] = MI.addAudio("win_FlaskHigh_" + i + "x");
            this.sounds["win_Candle_" + i + "x"] = MI.addAudio("win_Candle_" + i + "x");
            this.sounds["win_Pestle_" + i + "x"] = MI.addAudio("win_Pestle_" + i + "x");
        }

        events.subscribe(GAME_EVENTS.GAME_ADD_RESULT, this._requestResult.bind(this));
        events.subscribe(GAME_EVENTS.GAME_END_ROUND_RECALCED, this._endRoundRecalced.bind(this));
    },

    canRemoveBet: function() {

        if(this.inFreeSpins || !this._removeBetEnabled /*|| MI.isLastRoundAutostart()*/)
        {
            return false;
        }

        return true;
    },

    /**
     * @param {boolean} bool FALSE to disable remove bet
     * @returns {undefined}
     */
    enableRemoveBet: function(bool) {
        this._removeBetEnabled = bool;
    },

    /**
     * @returns {boolean}
     */
    isInAutostart: function() {
        return MI.isAutoStartSet();
    },

    /**
     * If in autostart, returns false
     * @returns {boolean}
     */
    autostartRemoveBetNextSpin: function() {
        if(this.isInAutostart()) {
            return false;
        } else {
            return true;
        }
    },

    endAutostart: function() {
        MI.endAutoStart();
    },

    spinStart: function() {

        var _self = this;

        if(!this.spinEnabled) {
            return;
        }

        this.spinEnabled = false;

        MI.controls.unsetForceStop();
        this._forceAutostartEnabled = false;
        this._resultRequestLock = false;

        MI.setState("ROTATED", 1);
        // MI.controls.showStop();
        MI.controls.winAnimReset();

        madnes_reels_start();

        // this._decreaseAutoStartCount();
        this._increaseFreeSpins();

        // var money = MI.getMoney();

        // this._removeBet();

        if(this.inFreeSpins) {
            //MI.server.setRoundRunning(true);
            this.freeSpinData['pos']++;
            this.assets.setFsInfo(this.freeSpinData['pos'], this.freeSpinData['count']);
        }

        var allStopped = [];

        this.sounds["reel_Spin"].play();

        // this._requestResult(money);

        for(var i = 0; i < this.spinReels.getReels().length; i++) {

            var reel = this.spinReels.getReel(i);
            reel.motion.reinitSpeed();

            reel.showSymbols();
            //reel.hideInvisibleSymbols();

            //reel.createSpinSymbols(this.spinReels.symbolsGroup);
            reel.createBlurSymbols(reel.spinSymbols);
            reel.reviveSpinSymbols();

            reel.setTmpSymbols();
            reel.initTmpSymbols();
            reel.reelSymbols.length = 0;
            reel.reinitPositions();

            this.assets.fadeOutColorFrames(reel);

            this._stoppedScatterIndex = 0;

            (function(reel, allStopped) {

                var running = reel.start();

                allStopped.push(running);

                reel.onSpin(function() {

                    reel.stopStandAnim(reel.tmpSymbols);
                    reel.createBlurTmpSymbols(_self.spinReels.symbolsGroup);

                    reel.showInvisibleSymbols();

                });

                reel.onBrakeDown(function() {

                    if (reel.id === 3) {
                        MV.states.setState(STATES.FORCESPIN);
                    }

                    _self._playStopSound(reel);

                    reel.removeHidedSymbols();
                    reel.createSymbols();
                    reel.createStandAnim();

                    reel.landAnim();

                    _self.assets.colorizeReelFrames(reel);
                });

                reel.onBrakeUp(function() {
                    if(reel.id === 3 && _self._getServerResult().getSearchingScatter() < 2 && !_self._getServerResult().getLineWins()) {
                        _self._forceAutostartEnabled = true;
                        MI.controls.showSpin();
                    }
                });

                reel.onStop(function() {

                    if(!MI.controls.isForceStop()) {
                        _self._fadeInOutFreeSpinSearch(reel, _self._getServerResult().getSearchingScatter());
                    }

                    if(reel.id === 0 && _self._getServerResult().getSearchingScatter() >= 1 && !MI.controls.isForceStop()) {
                        _self.sounds["bonus_Scatter_1"].play();

                        var soundName = _self.inFreeSpins ? "bg_FreeSpins_Loop" : "bg_Music";
                        _self.sounds[soundName].fadeOut(200, true);
                    }

                    if(reel.id === 2 && _self._getServerResult().getSearchingScatter() > 1 && !MI.controls.isForceStop()) {
                        _self.sounds["bonus_Scatter_2"].play();
                    }

                    _self._setReelSpeed(reel, _self._getServerResult());

                    reel.removeTmpSymbols();
                    reel.playStandAnim();

                    reel.searching = false;
                });

            }(reel, allStopped));
        }

        Promise.all(allStopped).then(function() {

            /*if(this.waitForWinAdd) {
                this.waitForWinAdd.then(function() {
                    this._reelsStopped();
                }.bind(this));
            } else {*/
            _self._reelsStopped();
            /*}*/

        });

        this.spinReels.startSpinReels();
    },

    /**
     * @param {number} money
     * @private
     */
    _requestResult: function() {
        if(this._resultRequestLock) {
            return;
        }

        this._resultRequestLock = true;

        this._getResult().then(function() {

            for(var i = 0; i < this.spinReels.getReels().length; i++) {
                this.spinReels.getReel(i).addSymbolsToStop(this._getReelDuration(i, this._getServerResult().getSearchingScatter()));
                this.spinReels.getReel(i).stop();
            }

        }.bind(this));
    },

    /**
     * @return {Promise<any>}
     * @private
     */
    _getResult: function() {

        var _self = this;

        return new Promise(function(res) {

            if(_self.inFreeSpins) {

                setTimeout(function() {

                    _self._fsServerResult = _self._serverResult.getFreeSpinResult(_self.inFreeSpinsIndex);
                    //var searchScatter = _self._getServerResult().getSearchingScatter();

                    _self.spinReels.prepareResult(_self._fsServerResult.getReelMatrix(0)/*, searchScatter*/);
                    res();

                }, 200);

            } else {

                // MI.server.loadResult({money: money}).then(function() {

                    //setTimeout(function() {

                    _self._serverResult.init(MI.server.getResult());
                    //var searchScatter = _self._getServerResult().getSearchingScatter();

                    _self.spinReels.prepareResult(_self._serverResult.getReelMatrix(0)/*, searchScatter*/);
                    res();

                    //}, 3000);
                // });
            }
        });
    },

    _reelsStopped: function() {
        this.spinReels.stopSpinReels();
        this.spinReels.reinitSpreaded();

        for(var i = 0; i < this.spinReels.getReels().length; i++) {
            var reel = this.spinReels.getReel(i);
            reel.killSpinSymbols();
        }

        if(MI.controls.isForceStop()) {
            this.sounds["bonus_Scatter_1"].fadeOut(200, true);
            this.sounds["bonus_Scatter_2"].fadeOut(200, true);

            this.assets.stopSearchTweens();
            this.assets.fadeOutAllSearch();
        }

        //console.log(!this.stopBonusScatterSound() && this._isScatter());

        if(!this.stopBonusScatterSound() && this._isScatter()) {
            this.sounds["bonus_Scatter_3"].play();
            this._playBgScatterIdle();
        }

        this._forceStopSoundPlayed = false;
        this._forceScatterSoundPlayed = false;
        this._forceWildSoundPlayed = false;
       wallet.setWinDecimalPlaces(this._getServerResult().getWin())

//		setTimeout(function() {
        madnes_reels_stop();
        this._resultController.control(this._getServerResult());
//		}.bind(this), 120);
    },

    /**
     * @returns {boolean}
     */
    _isScatter: function() {
        return !!(this._getServerResult().getLineWins() && this._getServerResult().getSearchingScatter() > 1);
    },

    /**
     * @returns {ServerResult}
     */
    _getServerResult: function() {
        return this._fsServerResult ? this._fsServerResult : this._serverResult;
    },

    /**
     * @public
     * @param {boolean=} pickSkipped
     * @returns {Promise}
     */
    enterFreeSpins: function(pickSkipped) {

        var _self = this;

        return new Promise(function(res) {

            _self.inFreeSpins = true;

            // if(!pickSkipped) {
            //     _self._serverResult.init(MI.server.getPlayersPick());
            // }

            let fsCurrent = MV.freespins.getFreeSpinNumber();
            MV.game.freespins.run(new AddResult(_self._serverResult.data));
            let fsTotal = MV.freespins.getFreeSpinNumber();

            _self.freeSpinData["count"] = _self._serverResult.getFreeSpinResults().length;
            _self.freeSpinData["roundWin"] = 0;


            // var cpos = MI.getCookie("lfspos_" + MI.server.getSessionId());
            if(MV.game.freespins.isSkipping() /*typeof cpos !== 'undefined' && cpos >= 0*/) {

                _self.inFreeSpinsIndex = MV.freespins.getRoundIndex(); // cpos * 1;

                var fsResult = _self._serverResult.getFreeSpinResult(_self.inFreeSpinsIndex);

                _self.freeSpinData["count"] = fsTotal; //fsResult.getFreeSpinNumber();
                _self.freeSpinData["pos"] = MV.freespins.getRoundNumber(); //cpos * 1 + 1;

                _self.setWin(MV.game.freespins.getResultWin());
                // _self.addWin(MV.game.freespins.getWinSum());

                // if(typeof fsResult.getWin() !== 'undefined') {
                //     _self.setWin(fsResult.getWin());
                // }
            }

            _self.sounds["bg_Scatter_Idle"].fadeOut(300, true);


            _self.assets.hideLightFramesFs();
            _self.assets.fadeInFreeSpin();

//			var t = new Date();

            if(pickSkipped) {

                _self.sounds["bg_FreeSpins_Loop"].loop();

                _self.assets.createFsInfo();

                _self.assets.hideLogo().then(function() {
                    _self.assets.playFsInfoAnim(_self.freeSpinData["pos"], _self.freeSpinData['count']).then(res);
                });

            } else {

                _self.sounds["bg_FreeSpins_Start"].play();

                MI.createTimer().add(function() {
//					console.log(new Date() - t);
                    //console.log(_self.sounds["bg_FreeSpins_Start"].getVolume(), _self.sounds["bg_FreeSpins_Loop"].getVolume());
                    _self.sounds["bg_FreeSpins_Loop"].loop(_self.sounds["bg_FreeSpins_Start"].getVolume());
                }, 9000);

                res();
            }
        });
    },

    leaveFreeSpins: function() {
        var _self = this;

        this.reinitFreespinData();

        this.assets.hideFsInfoAnim().then(function() {
            _self.assets.showLogo();
        });

        this.inFreeSpins = false;
        this.inFreeSpinsIndex = -1;
        this._fsServerResult = null;
    },

    /**
     * @public
     * @returns {boolean}
     */
    isNextRoundFreeSpin: function() {
        return !!this._serverResult.getFreeSpinResult(this.inFreeSpinsIndex + 1);
    },

    setWin: function(amount) {
        MI.setWin(amount);
        this.freeSpinData["roundWin"] = amount;
    },

    /**
     * @param {number} amount
     * @returns {undefined}
     */
    addWin: async function(amount) {
        await madnes_add_win(amount);
        this.freeSpinData["roundWin"] += amount;
    },

    /**
     * @returns {number} money in real
     */
    getWin: function() {
        return MI.getWin();
    },

    /**
     * @returns {boolean}
     */
    isWin: function() {
        return this.getWin() > 0;
    },

    /**
     * @param {number} amount
     * @returns {boolean}
     */
    isBigWin: function(amount) {
        return amount >= MI.getBigWinFactor() * this.getWin();
    },

    /**
     * @param {number} amount
     * @returns {boolean}
     */
    isMegaWin: function(amount) {
        return amount >= MI.getMegaWinFactor() * this.getWin();
    },

    /**
     * @param {number} amount
     * @returns {boolean}
     */
    isSuperMegaWin: function(amount) {
        return amount >= MI.getSuperMegaWinFactor() * this.getWin();
    },

    isBonusWin: function() {
        return false;
    },

    /**
     * @param {number} reelId
     * @param {number} searchingType
     * @returns {number}
     */
    _getReelDuration: function(reelId, searchingType) {

        //return 0;

        let commonSpeed = this._serverConfig.getSpinCommonSpeed();
        let scatterSpeed = this._serverConfig.getSpinScatterSpeed();
        let diff =  commonSpeed / scatterSpeed;

        if(searchingType === 2) {

            switch(reelId) {
                case 0:
                    return 0;
                case 1:
                    return this._serverConfig.getDelayBetweenReelStops();
                case 2:
                    return this._serverConfig.getScatterDuration();
                case 3:
                    return this._serverConfig.getScatterDelay()*diff + this._serverConfig.getDelayBetweenReelStops() * reelId;
                case 4:
                    return this._serverConfig.getScatterDelay()*diff + this._serverConfig.getScatterDuration() + this._serverConfig.getDelayBetweenReelStops();
            }
        } else if(searchingType === 1) {

            switch(reelId) {
                case 0:
                    return 0;
                case 1:
                    return this._serverConfig.getDelayBetweenReelStops();
                case 2:
                    return this._serverConfig.getScatterDuration();
                case 3:
                    return this._serverConfig.getScatterDelay()*diff + this._serverConfig.getDelayBetweenReelStops() * reelId;
                case 4:
                    return this._serverConfig.getScatterDelay()*diff + this._serverConfig.getDelayBetweenReelStops() * reelId;
            }

        }
        return reelId * (this._serverConfig.getDelayBetweenReelStops());
    },

    /**
     * @param {SpinReel} reel
     * @param {ServerResult} serverResult
     * @returns {undefined}
     */
    _setReelSpeed: function(reel, serverResult) {
        var _self = this;

        //return;
        var searchingType = serverResult.getSearchingScatter();

        if(searchingType === 1 || searchingType === 2) {
            if(reel.id === 0 && !MI.controls.isForceStop()) {
                this.spinReels.getReel(2).searching = true;

                this.spinReels.getReel(2).motion.slowDown(this._serverConfig.getSpinScatterSpeed(), function() {
                    _self.spinReels.getReel(2).unblurSpinSymbols();
                });

            }

            if(reel.id === 2 && searchingType === 2 && !MI.controls.isForceStop()) {
                this.spinReels.getReel(4).searching = true;
                this.spinReels.getReel(4).motion.slowDown(this._serverConfig.getSpinScatterSpeed(), function() {
                    _self.spinReels.getReel(4).unblurSpinSymbols();
                });
            }
        }

        //if(searchingType === 1)
    },

    /**
     * @param {SpinReel} reel
     * @param {number} searchingType
     * @returns {undefined}
     */
    _fadeInOutFreeSpinSearch: function(reel, searchingType) {

        if(searchingType === 2) {
            if(reel.id === 0) {
                this.assets.fadeInFreeSpinSearch(2);
            }
            if(reel.id === 2) {
                this.assets.fadeOutFreeSpinSearch(2);
                this.assets.fadeInFreeSpinSearch(4);
            }

            if(reel.id === 4) {
                this.assets.fadeOutFreeSpinSearch(4);
            }
        }

        if(searchingType === 1) {
            if(reel.id === 0) {
                this.assets.fadeInFreeSpinSearch(2);
            }
            if(reel.id === 2) {
                this.assets.fadeOutFreeSpinSearch(2);
            }
        }
    },

    /**
     * @private
     */
    _decreaseAutoStartCount: function() {
        if(MI.getAutoStart() !== "∞" && MI.getAutoStart() > 0 && !this.inFreeSpins) {
            MI.autoStartDec();
        }
    },

    _increaseFreeSpins: function() {
        if(this.inFreeSpins) {
            this.inFreeSpinsIndex++;
        }
    },

    /**
     * @param {SpinReel} reel
     */
    _playStopSound: function(reel) {

        if(reel.forceStopping) { //in force stop, play stop sound only once

            if(reel.hasScatter()) {

                // if(!this._forceScatterSoundPlayed) {
                        this.sounds["symbol_Scatter_" + (this._stoppedScatterIndex + 1)].play();
                        this._stoppedScatterIndex++;
                    // }
                    this._forceScatterSoundPlayed = true;
                // }
                return;
            }


            if(reel.hasWild()) {
                if(!this._forceWildSoundPlayed) {
                    this.sounds["symbol_Wild"].play();
                    this._forceWildSoundPlayed = true;
                }
                return;
            }


            if(this._forceStopSoundPlayed) {
                this.sounds["reel_Stop"].play();
                this._forceStopSoundPlayed = true;
            }

            return;
        }

        if(reel.hasScatter()) {
            this.sounds["symbol_Scatter_" + (this._stoppedScatterIndex + 1)].play();
            this._stoppedScatterIndex++;
            return;
        }

        if(reel.hasWild()) {
            this.sounds["symbol_Wild"].play();
            return;
        }

        this.sounds["reel_Stop"].play();
    },

    _getScatterSoundId: function(reelId) {
        switch(reelId) {
            case 0: return 1;
            case 2: return 2;
            case 4: return 3;
        }
    },

    setForceAutostartEnabled: function(enabled) {
        this._forceAutostartEnabled = enabled;
    },

    spinReleased: function() {
        if(/*MI.getState("ROTATED") && */ this._forceAutostartEnabled) {
            this._resultController.setForceAutostart(true);
        }
        this._forceAutostartEnabled = false;
    },

    forcestopPressed: function() {
        this._resultController.setForceAutostart(false);
    },

    fsChoosed: function() {
        let rid = this._serverResult.getRoundId();
        return freespins.isStored(rid);
        // return MI.getCookie("lfspos_" + MI.server.getSessionId()) !== undefined;
    },

    _endRoundRecalced: function() {
        this.spinEnabled = true;
        MI.setInMoneyAdd(false);
    }
};